import React from "react";
import { ReactComponent as EmailIcon } from "./icons/descriptive/email.svg";
import { ReactComponent as PaperIcon } from "./icons/descriptive/paper.svg";
import { ReactComponent as WhatsAppIcon } from "./icons/logos/whatsapp.svg";
import { ReactComponent as RightHeadIcon } from "./icons/arrowheads/righthead.svg";
import { ReactComponent as LeftHeadIcon } from "./icons/arrowheads/lefthead.svg";
import { ReactComponent as RightArrowIcon } from "./icons/arrows/rightarrow.svg";
import { ReactComponent as LeftArrowIcon } from "./icons/arrows/leftarrow.svg";
import { ReactComponent as XIcon } from "./icons/actionables/ex.svg";

interface ButtonProps {
  label: string;
  onClick?: () => void;
  // eslint-disable-next-line no-unused-vars
  onSubmit?: (e: React.FormEvent) => void;
  type?: "submit" | "button";
  w?: string;
  h?: string;
  icon?: string;
}

export const WhatsAppButton: React.FC<ButtonProps> = ({
  label,
  onClick,
  w,
  h,
}) => {
  return (
    <button
      style={{ width: w, height: h }}
      className="flex justify-center items-center m-1 gap-2 bg-gradient-to-b from-[#1FAF38] to-[#60D669] rounded-[32px] text-white font-montserrat font-semibold text-[16px] leading-[20px]"
      onClick={onClick}
    >
      <WhatsAppIcon style={{ height: "20px", width: "20px", fill: "#FFFFFF" }} />
      {label}
    </button>
  );
};

export const EmailButton: React.FC<ButtonProps> = ({
  label,
  onClick,
  w,
  h,
}) => {
  return (
    <button
      style={{ width: w, height: h }}
      className="flex justify-center items-center m-1 gap-2 w-[395px] h-[44px] bg-[#5A6ED5] rounded-[32px] text-white font-montserrat font-semibold text-[16px] leading-[20px]"
      onClick={onClick}
    >
      <EmailIcon style={{ height: "20px", width: "20px", fill: "#FFFFFF" }} />
      {label}
    </button>
  );
};

export const GrayButton: React.FC<ButtonProps> = ({
  label,
  onClick,
  w,
  h,
  icon,
}) => {
  let iconComponent = null;
  if (icon === "righthead") {
    iconComponent = (
      <RightHeadIcon style={{ height: "20px", width: "20px", fill: "black" }} />
    );
  } else if (icon === "lefthead") {
    iconComponent = (
      <LeftHeadIcon style={{ height: "20px", width: "20px", fill: "black" }} />
    );
  } else if (icon === "rightarrow") {
    iconComponent = (
      <RightArrowIcon
        style={{ height: "20px", width: "20px", fill: "black" }}
      />
    );
  } else if (icon === "leftarrow") {
    iconComponent = (
      <LeftArrowIcon style={{ height: "20px", width: "20px", fill: "black" }} />
    );
  } else if (icon ==="X") {
    iconComponent = (
      <XIcon style={{ height: "20px", width: "20px", fill: "black", flexShrink: 0}} />
    );
  } else if (icon === "paper") {
    iconComponent = (
      <PaperIcon style={{ height: "20px", width: "20px", fill: "black" }} />
    );
  }

  return (
    <button
      style={{ width: w, height: h }}
      //className="flex justify-center items-center bg-[#EAEBF0] rounded-[32px] text-black font-montserrat text-[16px] leading-[20px] p-4"
      className="inline-flex justify-center items-center bg-[#EAEBF0] rounded-[32px] text-black font-montserrat text-[16px] leading-[20px] px-4 gap-2"
      onClick={onClick}
    >
      <div className="flex items-center justify-center gap-2 p-3">
        {label}
        {iconComponent}
      </div>
    </button>
  );
};


export const GrayButton2: React.FC<ButtonProps> = ({
  label,
  onClick,
  w,
  h,
  icon,
}) => {
  let iconComponent = null;
  if (icon === "righthead") {
    iconComponent = (
      <RightHeadIcon style={{ height: "20px", width: "20px", fill: "black" }} />
    );
  } else if (icon === "lefthead") {
    iconComponent = (
      <LeftHeadIcon style={{ height: "20px", width: "20px", fill: "black" }} />
    );
  } else if (icon === "rightarrow") {
    iconComponent = (
      <RightArrowIcon style={{ height: "20px", width: "20px", fill: "black" }}/>
    );
  } else if (icon === "leftarrow") {
    iconComponent = (
      <LeftArrowIcon style={{ height: "20px", width: "20px", fill: "black" }} />
    );
  }

  return (
    <button
      style={{ width: w, height: h }}
      className="flex justify-center items-center bg-[#EAEBF0] rounded-[32px] text-black font-montserrat text-[16px] leading-[20px] p-[5%]"
      onClick={onClick}
    >
      <div className="flex items-center justify-center gap-2">
        {iconComponent}
        {label}
      </div>
    </button>
  );
};


export const BlueButton: React.FC<ButtonProps> = ({ label, onClick, w, h }) => {
  return (
    <button
      style={{ width: w || "395px", height: h || "44px" }}
      className="inline-flex justify-center items-center bg-[#5A6ED5] rounded-[32px] text-white font-montserrat text-[16px] leading-[20px] px-4 gap-2"
      onClick={onClick}
    >
      {label}
    </button>
  );
};

export const GradientButton: React.FC<ButtonProps> = ({
  label,
  onClick,
  w,
  h,
}) => {
  return (
    <button
      style={{
        width: w || "235px",
        height: h || "44px",
        background:
          "linear-gradient(90deg, #EBCF4D 0%, #64B6E5 58.5%, #5A6ED5 100%)",
      }}
      className="flex justify-center items-center m-1 gap-2 rounded-[32px] text-white font-montserrat font-semibold text-[16px] leading-[20px]"
      onClick={onClick}
    >
      {label}
    </button>
  );
};

